import React, { useEffect } from 'react'
import Loading from '../../components/Loading'
import { connect } from 'react-redux'
import { setTitle, getAll, deleted } from '../../actions'
import Table from '../../components/Table'
import { Link } from 'react-router-dom'
import Button from '../../components/Button'

const Users = props => {
  const { colors, setTitle } = props

  useEffect(() => {
    const topbar = {
      title: 'Marcas',
      buttonBar: (
        <Link to="/products/colors/create">
          <Button>Crear</Button>
        </Link>
      ),
    }
    setTitle(topbar)
    props.getAll('products/colors', 'GET_COLORS')
    // eslint-disable-next-line
  }, [])

  if (!colors) {
    return <Loading />
  }

  const columns = [
    {
      header: 'Nombre',
      accessorKey: 'name',
    },
  ]

  return (
    <>
      <Table
        data={colors}
        columns={columns}
        name="Colores"
        showColumnFilters={false}
        crud
        path="products/colors"
        actionAfterDelete={'GET_COLORS'}
        nameFile="Colores"
      />
    </>
  )
}

const mapStateToProps = state => {
  return {
    colors: state.products.colors,
  }
}

const mapDispatchToProps = {
  setTitle,
  getAll,
  deleted,
}

export default connect(mapStateToProps, mapDispatchToProps)(Users)
